/** A round opens on the same server deadline for every player. */
export const START_COUNTDOWN_MS = 3_000;

export function countdownStep(deadline: number, now: number): number {
  return Math.max(0, Math.min(3, Math.ceil((deadline - now) / 1_000)));
}
